import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import Template from "../Template";
import DashboardFilter from "./DashboardFilter";
import "../../styles/dashboard/dashboard.css";
import DashboardCard from "./DashboardCard";
import { GiTwoCoins } from "react-icons/gi";
import { BsHandbag } from "react-icons/bs";
import { HiOutlineTicket } from "react-icons/hi";
import { TiArrowRepeat } from "react-icons/ti";
import DashboardLineChart from "../../components/charts/DashboardLineChart";
import BarChart from "../../components/charts/BarChat";
import BarChatDesktop from "../../components/charts/BarChatDesktop";
import OnlineVistorsChat from "../../components/charts/OnlineVistorsChat";
import DoughnutChart from "../../components/charts/DoughnutChart";
import DoughnutChartDB from "../../components/charts/DoughNutDashboarChart";
import GaugeConRate from "../../components/charts/GaugeConRate";
import { getDashboardUrl } from "../../api/endpoints";
import { useState, useLayoutEffect } from "react";
import Spinner from "../../components/uxCollections/Loaders";
import { useNavigate } from "react-router-dom";
import { refreshUserToken } from "../../tools/refreshToken";
import { useSelector } from "react-redux";
import { monthNameShort } from "./DailyFilter";
import LoadingSkeleton from "../../components/uxCollections/skeletonLoader/dashboard/DashboardSkeletion";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const Dashboard = () => {
  const [filterRecordBasedOnStore, setFilterRecordBasedOnStore] = useState({ storeId: "1", storeName: "All Stores" });
  const [resetSToreFilter, setResetSToreFilter] = useState(false);
  const [disableStoreFilter, setDisableStoreFilter] = useState(false);
  const [rawData, setRawData] = useState();
  const [dashboardData, setDashboardData] = useState();
  const [dashboardDataCopy, setDashboardDataCopy] = useState(); /* for filtering */
  const [whichDashboardToRender, setWhichDashboardToRender] = useState("today"); /* today || yesterday */
  const [isLoading, setIsLoading] = useState(false); //
  const { user } = useSelector((state) => state.webStoreUser);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setIsLoading(true);
    getTodayOrYesterdayDashboard();
  }, []);
  useLayoutEffect(() => {
    if (filterRecordBasedOnStore.storeId === "1") {
      console.log("this useeffect runs");

      setDashboardData(dashboardDataCopy);
      return;
    } else {
      let filteredStoreData = Object.values(rawData)[0].filter((record) => record.storeID.toString() === filterRecordBasedOnStore.storeId.toString());
      console.log(filteredStoreData, "filteredStoreData");
      let newFilteredStoreData = {
        conversionRate: filteredStoreData[0].conversionRate || 0,
        totalOrders: filteredStoreData[0].totalOrders,
        totalReturned: filteredStoreData[0].totalReturns,
        totalSales: filteredStoreData[0].totalSales,
        stockValue: filteredStoreData[0].stockValue,
        storeID: filteredStoreData[0].storeID,
        onlineVisitors: Object.values(filteredStoreData[0].onlineVisitors),
        profit: Object.values(filteredStoreData[0].profit),
        expenses: Object.values(filteredStoreData[0].expenses),
        timeLine: Object.keys(filteredStoreData[0].profit),
        cashTransaction: filteredStoreData[0].transactionType[0].amount,
        loanTransaction: filteredStoreData[0].transactionType[1].amount,
        salesOnline: Object.values(filteredStoreData[0].sales).map((record) => record[0].online),
        salesOffline: Object.values(filteredStoreData[0].sales).map((record) => record[1].inStore),
        newCustomers: filteredStoreData[0].newCustomers,
      };
      console.log(newFilteredStoreData, "newFilteredStoreData");
      setDashboardData(newFilteredStoreData);
    }
  }, [filterRecordBasedOnStore]);

  useLayoutEffect(() => {
    console.log(whichDashboardToRender, "whichDashboardToRender");

    if (whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday") {
      console.log("custom dashboard");
      setDisableStoreFilter(true);
      return;
    } else {
      setDisableStoreFilter(false);
      setResetSToreFilter(!resetSToreFilter);
      getTodayOrYesterdayDashboard();
    }
  }, [whichDashboardToRender]);

  const getTodayOrYesterdayDashboard = async () => {
    setIsLoading(true);
    try {
      console.log("getting dashboard");

      let res = await fetch(getDashboardUrl + whichDashboardToRender, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (res.ok) {
        let { rawData, reducedData } = await res.json();
        setRawData(rawData);
        setDashboardData(reducedData);
        setDashboardDataCopy(reducedData);
        console.log(reducedData, rawData);
        setIsLoading(false);
      } else if (res.status === 400) {
        refreshUserToken(getDashboardUrl + whichDashboardToRender, getTodayOrYesterdayDashboard, navigate);
      } else {
        uiAlert("dahsboard not found", "error");
        //navigate("/sign-in");
        setIsLoading(false);
        setWhichDashboardToRender("today");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const trimDateStringtoFormat = (dateStringArray) => {
    /* 2024-01-01 to jan 1 */

    let trimedDateArray = dateStringArray.map((date) => {
      // Match YYYY-MM-DD exactly
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date.trim());
      if (!m) return date; // not a date; return unchanged
      if (date !== "total") {
        let dateArray = date.split("-");
        let month = dateArray[1];
        let day = dateArray[2];
        /*  if (month[0] === "0") {
          month = month[1];
        }
        if (day[0] === "0") {
          day = day[1];
        } */

        return `${monthNameShort[parseInt(month) - 1]}  ${day}`;
      } else {
        return date;
      }
    });

    return trimedDateArray;
  };

  const colorsArray = [
    "#E57373", // Red lighten-2
    "#F06292", // Pink lighten-2
    "#BA68C8", // Purple lighten-2
    "#9575CD", // Deep Purple lighten-2
    "#7986CB", // Indigo lighten-2
    "#64B5F6", // Blue lighten-2
    "#4FC3F7", // Light Blue lighten-2
    "#4DD0E1", // Cyan lighten-2
    "#4DB6AC", // Teal lighten-2
    "#81C784", // Green lighten-2
    "#AED581", // Light Green lighten-2
    "#DCE775", // Lime lighten-2
    "#FFF176", // Yellow lighten-2
    "#FFD54F", // Amber lighten-2
    "#FFB74D", // Orange lighten-2
    "#FF8A65", // Deep Orange lighten-2
    "#A1887F", // Brown lighten-2
    "#90A4AE", // Blue Grey lighten-2
  ];

  return (
    <>
      <Template>
        <h3 className='dashTiti48' style={{ marginBottom: "20px" }}>
          Sales Dashboard
        </h3>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          <div style={{ overflowX: "hidden" }}>
            <div className='customerFilter'>
              <SelectStoreTab updateSelectedStore={setFilterRecordBasedOnStore} resetFilter={resetSToreFilter} disableStoreFilter={disableStoreFilter} />

              <DashboardFilter
                dashboardTimeline={whichDashboardToRender}
                updateDateDashboardToRender={setWhichDashboardToRender}
                setDashboardData={setDashboardData}
                setRawData={setRawData}
                setIsLoading={setIsLoading}
                setDashboardDataCopy={setDashboardDataCopy}
              />
            </div>
            {/* <h4>Overview for all stores </h4> */}

            <div className='DashboardChatWrapper23'>
              <div>
                {/* start card div */}
                {dashboardData && (
                  <div className='cardWarper3994'>
                    <DashboardCard
                      data={{ title: "Total sales", amount: dashboardData.totalSales }}
                      icon={<BsHandbag color='#a08b4e' />}
                      bgColor={"#FBF5E3"}
                      currency={user.userCountryCurrencySymbol}
                    />
                    <DashboardCard
                      data={{ title: "Stock worth", amount: dashboardData.stockValue ? dashboardData.stockValue : "N/A" }}
                      icon={<GiTwoCoins color='#8F90C8' />}
                      bgColor={"#E1E5FD"}
                      currency={user.userCountryCurrencySymbol}
                    />
                    <DashboardCard
                      data={{ title: "Total orders", amount: dashboardData.totalOrders }}
                      icon={<HiOutlineTicket color='#EFB3B6' />}
                      bgColor={"#FFF0F2"}
                    />
                    <DashboardCard
                      data={{ title: "Total returned", amount: dashboardData.totalReturned }}
                      icon={<TiArrowRepeat color='#AFDDE9' />}
                      bgColor={"#E1F8FF"}
                    />
                  </div>
                )}
                {/* end */}
                <div className='lineChartDashDiv34'>
                  {/* start chart linw */}
                  <div className='legendChartTol'>
                    <h5>Profit vs Expense</h5>
                    <div>
                      <div className='legend1Db legend1Db2'></div> <p>Profit</p>{" "}
                      <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.profit[dashboardData?.profit.length - 1]?.toLocaleString()} )
                      </p>
                      <div className='legend1Db'></div>
                      <p>Expense</p>
                      <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.expenses[dashboardData?.expenses.length - 1]?.toLocaleString()} )
                      </p>
                    </div>
                  </div>
                  <div className='lineChartDIvsi99'>
                    {dashboardData && (
                      <DashboardLineChart
                        label={
                          whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                            ? trimDateStringtoFormat(dashboardData.timeLine, "lineChart")
                            : dashboardData.timeLine
                        }
                        profit={dashboardData.profit}
                        expenses={dashboardData.expenses}
                        currency={user.userCountryCurrencySymbol}
                        xAxisLabel={
                          whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                            ? whichDashboardToRender.includes("Week")
                              ? " Days (days of the week)"
                              : "month of " + whichDashboardToRender.split(" ")[1]
                            : "Hours (time of the day)"
                        }
                      />
                    )}
                  </div>

                  {/* end chart linw */}
                </div>
                <div className='dhBarChat12ksdiv'>
                  <div className='ttsalesBarchat'>
                    <div className='legendChartTol'>
                      <h5>Total sales</h5>
                      <div style={{ marginRight: "0" }}>
                        <div style={{ backgroundColor: "#a4cc47" }} className='legend1Db'></div> <p>In-store</p>
                        {/*  <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.salesOffline[dashboardData?.salesOffline.length - 1]} )
                      </p> */}
                        <div style={{ backgroundColor: "#5887DE" }} className='legend1Db legend1Db2'></div> <p>Online</p>
                        {/*   <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.salesOnline[dashboardData?.salesOnline.length - 1]} )
                      </p> */}
                      </div>
                    </div>
                    <div>
                      {" "}
                      {dashboardData && (
                        <BarChatDesktop
                          label={
                            whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                              ? trimDateStringtoFormat(dashboardData.timeLine, "bar chart")
                              : dashboardData.timeLine
                          }
                          online={dashboardData.salesOnline}
                          inStore={dashboardData.salesOffline}
                          currency={user.userCountryCurrencySymbol}
                        />
                      )}
                    </div>
                  </div>
                  <div className='onlineVistitorsDash01'>
                    <div className='legendChartTol'>
                      <h5>Online visitors</h5>
                      <div style={{ marginRight: "0" }}>
                        <div style={{ backgroundColor: "#E2CCCC" }} className='legend1Db '></div> <p>current</p>
                      </div>
                    </div>
                    <div>
                      {dashboardData && (
                        <OnlineVistorsChat
                          label={
                            whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                              ? trimDateStringtoFormat(dashboardData.timeLine, "online visitors")
                              : dashboardData.timeLine
                          }
                          visitors={dashboardData.onlineVisitors}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className='transactionsChartDB'>
                  <div className='legendChartTol'>
                    <h5>Transactions</h5>
                  </div>
                  <div>{dashboardData && <DoughnutChartDB transactionType={[dashboardData.cashTransaction, dashboardData.loanTransaction]} />}</div>
                  <div style={{ marginRight: "0", display: "flex", gap: "10px", justifyContent: "center", alignItems: "center", marginTop: "16px" }}>
                    <div style={{ backgroundColor: "#30A7EC" }} className='legend1Db'></div> <p>Paid</p>
                    <div style={{ backgroundColor: "rgb(204, 42, 99)" }} className='legend1Db legend1Db2'></div> <p>Amount on loan</p>
                  </div>
                </div>
                <div className='ConvervsationrateDb83'>
                  <h5>{filterRecordBasedOnStore.storeId === "1" ? "Average Productivity index" : "Productivity index"}</h5>

                  {dashboardData && <GaugeConRate conversionRate={parseInt(dashboardData.conversionRate, 10)} />}
                </div>
                <div className='dashboardinfoDiv'>
                  <h5> New Customers </h5>
                  <div
                    onClick={() => {
                      navigate("/customers");
                    }}
                    className='newCustomerDiv8376'
                    style={{ cursor: "pointer" }}
                  >
                    {dashboardData && dashboardData.newCustomers?.length > 0 ? (
                      dashboardData?.newCustomers.slice(0, 3).map((customer, index) => (
                        <div key={index} className='imagecust63hh'>
                          {" "}
                          {/* <img src={customer.avartar} /> */}
                          <div style={{ backgroundColor: `${colorsArray[Math.floor(Math.random() * colorsArray.length)]}` }}>
                            {customer.fullName.slice(0, 1).toUpperCase()} <br />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>
                        <p style={{ color: "rgba(241, 241, 241, 0.5)", fontSize: "0.9rem" }}>
                          {whichDashboardToRender === "today" ? "No new customer today" : "No new customer in this time"}
                        </p>
                      </div>
                    )}
                    {/* <div className='imagecust63hh'>
                    {" "}
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyzTWQoCUbRNdiyorem5Qp1zYYhpliR9q0Bw&s' />
                  </div>
                  <div className='imagecust63hh'>
                    {" "}
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyzTWQoCUbRNdiyorem5Qp1zYYhpliR9q0Bw&s' />
                  </div> */}
                    {dashboardData && dashboardData.newCustomers?.length > 3 && (
                      <div className='plusMore7354'>
                        <p>+ {dashboardData.newCustomers?.length - 3} more</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/*  {isLoading && <Spinner position={"absolute"} transparent={false} />} */}
      </Template>
    </>
  );
};

export default Dashboard;
